import { defineStore } from "pinia";

export const idStore = "exportarRelatorioStore";

export type TExportarRelatorioStore = {
  competenciaDe: string;
  competenciaAte: string;
  regimeDeCompetencia: boolean;
  modelo: string;
};

export const useExportarRelatorioStore = defineStore(idStore, {
  state: (): TExportarRelatorioStore => ({
    competenciaDe: "",
    competenciaAte: "",
    regimeDeCompetencia: false,
    modelo: ""
  }),
  actions: {
    setDados(dados: TExportarRelatorioStore) {
      this.competenciaDe = dados.competenciaDe || "";
      this.competenciaAte = dados.competenciaAte || "";
      this.regimeDeCompetencia = dados.regimeDeCompetencia || false;
      this.modelo = dados.modelo || "";
    }
  }
});
